const private_network = {
	index: {
		empty: {
			description: "Your account does not have any private networks yet.",
			title: "No Private Networks Found...",
		},
		notifications: {
			create: "Creating private network <strong>{{name}}</strong>... This may take a moment.",
			create_already_existing:
				"Cannot create private network <strong>{{name}}</strong>. This name is already in use.",
			delete: "Private network <strong>{{name}}</strong> has been successfully deleted.",
			update: "Private network <strong>{{name}}</strong> has been successfully updated.",
			update_already_existing:
				"Cannot update private network <strong>{{name_current}}</strong>. There is already a private network with the name <strong>{{name_new}}</strong>.",
		},
		search: {
			label: "Search Private Network",
			placeholder: "Network X",
		},
		title: "Private Network Overview",
	},
	management: {
		dialog_create: {
			description: "Add your new private network here.",
			title: "Add Private Network",
		},
		dialog_delete: {
			description: `Are you sure you want to delete the private network <strong>{{name}}</strong>? 
                <br/>
                <br/>
                <strong>Caution!</strong>
                All connected VPS will be disconnected, and redundant interfaces will be removed from those VPS.`,
			title: "Delete Private Network",
		},
		dialog_qemu_connect: {
			button: "Select VPSs",
			description: "Select one of your VPSs that is not yet connected to a network.",
			no_internet_connection: "No Internet Connection",
			title: "Add VPS to Network",
		},
		dialog_qemu_delete: {
			description:
				"Are you sure you want to remove VPS <strong>{{name}}</strong> from the network?",
			title: "Remove VPS from Network.",
		},
		dialog_qemu_select: {
			costs: "Price € {{costs}} per month",
			description: "Here are the VPSs that can be connected to the private network.",
			empty: {
				title: "No available VPS found.",
				tooltip:
					"No VPSs were found that are not yet connected to a private network. Remove VPSs from another private network first or add new VPSs.",
			},
			title: "Select Available VPS",
		},
		info: {
			title: "Properties",
		},
		notifications: {
			create: "The selected VPSs have been successfully added to the private network.",
			delete: "VPS <strong>{{name}}</strong> has been successfully removed from the network.",
		},
		qemus: {
			description:
				"Connect VPS together through a private network. The VPS will have a separate network interface for this purpose. VPSs in the same network can communicate with each other. You only need to configure IP addresses on this internal interface.",
			table: {
				connection: ["Yes", "No"],
				empty: "No VPS found in the network.",
				header: ["VPS", "Status", "Internet Connection?"],
				status: ["Running", "Stopped"],
			},
			title: "VPS in Network",
		},
		title: "Private Network",
	},
	overview_card: {
		description: "Description",
		name: "Name",
	},
};

export default private_network;
